import { endAssignment } from 'modules/employeeActionsForm/components/EndAssignment/store/reducers';
import {
    createEmployeeActionForm,
    getEafReasons,
    resetEafSearchItems,
    searchEafForUser,
} from 'modules/employeeActionsForm/store/actions';
import { combineReducers } from 'redux';
import { isLoadingReducer, resetStateReducer, singleValueReducer } from 'store/reducerUtils';
import { extendReducer } from '../../../store/utils/reducers/extendReducer';
import { IEafEmailResult } from './models';

const reasons = singleValueReducer(getEafReasons.successType, []);
const isCreating = isLoadingReducer(createEmployeeActionForm);

const searchEaf = extendReducer(
    singleValueReducer(searchEafForUser.successType, {} as IEafEmailResult),
    resetStateReducer(resetEafSearchItems.action, {} as IEafEmailResult),
);

export const employeeActonForm = combineReducers({
    reasons,
    endAssignment,
    isCreating,
    searchEaf,
});
